import React from "react";
import clsx from "clsx";
import { Spinner } from "./Spinner";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isLoading?: boolean;
  variant?: "primary" | "secondary" | "danger" | "outline";
  size?: "sm" | "md" | "lg"; // FIX: Added size prop
}

export const Button: React.FC<ButtonProps> = ({
  children,
  className,
  isLoading,
  variant = "primary",
  size = "md", // Default size
  disabled,
  ...props
}) => {
  const baseStyles = "inline-flex items-center justify-center font-medium rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed";
  
  const variants = {
    primary: "bg-orange-600 text-white hover:bg-orange-700 focus:ring-orange-500 border border-transparent",
    secondary: "bg-white text-gray-700 hover:bg-gray-50 focus:ring-gray-500 border border-gray-300",
    danger: "bg-red-600 text-white hover:bg-red-700 focus:ring-red-500 border border-transparent",
    outline: "bg-transparent text-orange-600 border border-orange-600 hover:bg-orange-50 focus:ring-orange-500"
  };

  const sizes = {
    // min-h ensures ≥44px primary touch targets on mobile
    sm: "px-3 py-2 text-xs min-h-[40px] sm:min-h-0 sm:py-1.5",
    md: "px-4 py-2.5 text-sm min-h-[44px]",
    lg: "px-6 py-3 text-base min-h-[48px]",
  };

  return (
    <button
      className={clsx(baseStyles, variants[variant], sizes[size], className)}
      disabled={isLoading || disabled}
      {...props}
    >
      {isLoading && (
        <span className="mr-2">
          <Spinner size={size === 'sm' ? 12 : 16} color="current" />
        </span>
      )}
      {children}
    </button>
  );
};